import './applied_mention_view.js.coffee';# Added by Script 
class Monitoring.Views.SocialContents.Filters.AppliedPostMentionView extends Monitoring.Views.SocialContents.Filters.AppliedMentionView
  name: 'post_mentions'
  alias: 'Mentions'

  removeFilter: (value) ->
    @searchQuery.removePostMention(value)